// extracted by extract-css-chunks-webpack-plugin
module.exports = {"primary":"#4caf50","secondary":"#4caf50","tertiary":"#495057","accent":"#82b1ff","error":"#f55a4e","info":"#00d3ee","success":"#5cb860","warning":"#ffa21a"};